<template>

    <div class="bg-sn-light-grey min-h-screen">

        <NuxtPage />

    </div>

</template>

<script setup lang="ts">

</script>